'use client'

import { ButtonLink, FeatureFlag } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { Row } from '@repo/ui/components'
import { useParams } from 'next/navigation'

export const BalanceProjectNavbar = () => {
  const { t } = useTranslate()
  const { id } = useParams()
  return (
    <Row className='fixed bottom-0 left-0 w-full right-0 justify-between h-fit gap-md p-md bg-neutral-surface-light rounded-t-sm border-t  border-neutral-surface-dark shadow-sm'>
      <FeatureFlag flagKey='advanced-trade'>
        <ButtonLink
          href={`/advanced-trade?tab=detail&token=${id}`}
          width='full'
          variant='ghost'
          color='negative'
        >
          {t('walletPage_sell_in_market')}
        </ButtonLink>
      </FeatureFlag>
      <ButtonLink
        href={`/quick-trade?projectId=${id}&type=sell`}
        width='full'
        variant='fill'
        color='negative'
        className='w-full'
      >
        {t('walletPage_sell_in_market_instant')}
      </ButtonLink>
    </Row>
  )
}
